import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
/**
 * Animates the horizontal blocks
 */
window.addEventListener('load', () => {
	if (!window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
		return;
	}
	if (document.querySelectorAll('.testimonials-v2').length <= 0) {
		return;
	}

	const panelContainers = document.querySelectorAll('.testimonials-v2 [data-panel-container]');
	panelContainers.forEach((panelContainer) => {
		strlAnimateSteps(panelContainer);
	});

	function strlAnimateSteps(panelContainer) {
		if (!panelContainer) {
			return;
		}
		const panel = panelContainer.querySelector('[data-panel-wrapper]');
		let start = 'top-=' + window.innerHeight / 4 + ' top';
		if (window.innerWidth < 576) {
			start = 'top top+=' + window.innerHeight / 4;
		}

		let scrollWidth = panelContainer.scrollWidth - innerWidth;
		const scrollTween = gsap.to(panel, {
			x: () => -1 * (panelContainer.scrollWidth - innerWidth),
			ease: 'none',
			scrollTrigger: {
				trigger: panelContainer,
				pin: true,
				start: start,
				scrub: 1,
				end: () => '+=' + scrollWidth,
			},
		});

		ScrollTrigger.refresh();

		if (window.innerWidth > 1024) {
			strlAnimateStepInner(panelContainer, scrollTween);
		}
	}

	function strlAnimateStepInner(panelContainer, scrollTween) {
		const images = gsap.utils.toArray(panelContainer.querySelectorAll('[data-panel-image]'));
		const authors = gsap.utils.toArray(panelContainer.querySelectorAll('[data-panel-author]'));
		gsap.set(images, {
			width: 'calc(100% + 30px)',
			maxWidth: 'calc(100% + 30px)',
		});
		gsap.set(authors, {
			x: '60',
		});

		images.forEach((image) => {
			gsap.to(image, {
				scrollTrigger: {
					trigger: image,
					containerAnimation: scrollTween,
					start: 'center 90%',
					end: 'center 0%',
					scrub: 1,
				},
				x: '-30',
			});
		});
		authors.forEach((number) => {
			gsap.to(number, {
				scrollTrigger: {
					trigger: number,
					containerAnimation: scrollTween,
					start: 'center 100%',
					end: 'center 0%',
					scrub: 1,
				},
				x: '-150',
			});
		});
	}
});
